<template>
  <div class="bg-gray-21 p-3">
    <div class="d-flex justify-content-end">
      <action-button
        class="btn-warning-outline px-4 py-2 mr-2"
        :text="$t('GoBack')"
        i="fa fa-arrow-circle-left"
        @click="$router.go(-1)"
      />

      <action-button
        class="btn-success px-4 py-2"
        :text="$t('ChangeQuestionButtonText')"
        i="fa fa-save"
        @click="onSaveHandler"
      />

    </div>
    <validation-observer ref="formRef" v-slot="{}" tag="form">
      <div class="bg-white rounded p-4 mt-4">
        <div class="d-flex align-items-center">
          <em class="fal fa-ellipsis-h color-orange-light-2 mr-3 font-40" />
          <span class="color-dark-blue font-14 font-weight-bold">
            {{ $t('ChangeQuestionTitle') | upper }}
          </span>
        </div>
        <div class="row mt-2">
          <div class="col-md-5">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('NewQuestion') }}:
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-drop-down
                label=""
                placeholder="Seleccione"
                :options="options.securityQuestions"
                fieldkey="id"
                fieldname="name"
                v-model="model.question"
                @input="() => {}"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
          <div class="col-md-5">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('NewAnswer.Text') }}:
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-input
                type="text"
                v-model="model.answer"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
          <!-- <div class="col-md-3">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('Password') | capitalize }}:
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-input
                type="password"
                v-model="model.password"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div> -->
        </div>
      </div>
    </validation-observer>

    <GenerateReportModal
      ref="generateReportModal"
      @close="onCloseGenerateReportModal"
      @accept="onOpenGenerateReportModal"
    />
  </div>
</template>

<script>
//TODO: (Move the component and instance to the right place)
import GenerateReportModal from '@/views/request/GenerateReportModal.vue';

//libs
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';

//services
import {
  getInitCreateAccount as _getInitCreateAccount,
  updateQuestionAnswer as _updateQuestion,
} from '@/services/app.api.js';

//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import { userMixin } from '@/mixins/user.mixin';

//utils
import { i18n, loadLanguageAsync } from '@/i18n.js';

//constants
import langTypes from '@/utils/constants/lang.js';
import { datetime } from '@/filters';

export default {
  name: 'ChangeQuestionView',
  mixins: [alertMixin, userMixin],
  components: {
    ActionButton,
    CustomInput,
    CustomDropDown,
    GenerateReportModal,
  },
  props: {
    isNewProfile: {
      type: Boolean,
      default: true,
    },
    userProfileInformation: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      //user account
      userId: null,
      password: '',
      question: null,
      answer: null,
    },
    options: {
      securityQuestions: [],
    },
  }),
  computed: {
    isEnLang() {
      return this.userSelectedLang === langTypes.EN;
    },
  },
  async created() {
    loadLanguageAsync();
  },
  async mounted() {
    await this.getInitCreateAccount();
  },
  methods: {
    datetime,
    async getInitCreateAccount() {
      const options = (await _getInitCreateAccount(this.isEnLang)).data;

      this.options = {
        ...this.options,
        ...options,
      };
    },

    async onSaveHandler() {
      const isValid = await this.$refs.formRef.validate();
      if (!isValid) {
        this.ShowToast(
          i18n.t('Alert'),
          `${i18n.t('PleaseCompleteRequestedInformation')}.`,
          'error'
        );
        return;
      }
      //get user id of route
      this.model.userId = this.$route.params.userId;
      const payload = {
        ...this.model,
        questionId: this.model.question?.id,
        isEn: this.isEnLang,
      };

      const updateResponse = await _updateQuestion(payload).catch((error) =>
        this.ShowToast('Error', error.response.data.message, 'error')
      );
      if (updateResponse) {
        const response = updateResponse.data;
        if (response.error) {
          this.ShowToast('Alerta', response.message, 'error');
          return;
        }
        this.ShowToast(
          i18n.t('ProcessSuccessfully'),
          i18n.t('ProfileInformationSuccessfully'),
          'success'
        );
      }
    },
    //TODO: (Move the component and instance to the right place)
    onOpenGenerateReportModal() {
      if (this.$refs.generateReportModal) {
        this.$refs.generateReportModal.showModal();
      }
    },
    onCloseGenerateReportModal() {
      this.$refs.generateReportModal?.hideModal();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';

.rb__extended ::v-deep {
  .col-12 {
    margin-left: -24px !important;
  }
}
</style>
